<div class="my-4">
  <img class="img-fluid  mx-auto d-block bs-img" src="../../../../assets/images/states/error.svg">
  <h5 class="text-muted text-center p-3">You need to get in first!</h5>
  <br>
  <div class="d-flex justify-content-center m-2">
    <button mat-button routerLink="/auth/login" color="primary">
      Login
      <mat-icon>login</mat-icon>
    </button>
    <button mat-button routerLink="/auth/signup" color="accent">
      SignUp
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </div>
</div>